import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { AlertCircle } from "lucide-react"
import { useState } from "react"
import { type TestBill } from "@/types/config"

interface AddBillDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (bill: TestBill) => void
}

export function AddBillDialog({ open, onOpenChange, onAdd }: AddBillDialogProps) {
  const [sessionCode, setSessionCode] = useState("")
  const [billNumber, setBillNumber] = useState("")
  const [error, setError] = useState<string>()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    // Basic validation
    if (!sessionCode.match(/^\d{4}RS$/)) {
      setError("Session code must be in format: YYYYRS")
      return
    }

    if (!billNumber.match(/^[HS]B\d{4}$/)) {
      setError("Bill number must be in format: HB0000 or SB0000")
      return
    }

    onAdd({ SessionCode: sessionCode, BillNumber: billNumber })
    onOpenChange(false)
    
    // Reset form
    setSessionCode("")
    setBillNumber("")
    setError(undefined)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Test Bill</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="sessionCode">Session Code</Label>
            <Input
              id="sessionCode"
              placeholder="2024RS"
              value={sessionCode}
              onChange={(e) => {
                setSessionCode(e.target.value)
                setError(undefined)
              }}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="billNumber">Bill Number</Label>
            <Input
              id="billNumber"
              placeholder="HB0000"
              value={billNumber}
              onChange={(e) => {
                setBillNumber(e.target.value)
                setError(undefined)
              }}
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 text-sm text-red-500">
              <AlertCircle className="h-4 w-4" />
              {error}
            </div>
          )}

          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">
              Add Bill
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}